// frontend/src/features/campaign/components/create/WizardFooter.js
import React from 'react';

export default function WizardFooter({
  wizardStep,
  onPrevStep,
  onNextStep,
  onCancel,
  isEditMode,
  isEditing = false,
  canDirectApprove = true,
  onSaveChanges,
  isSaving = false,
  isDisabled = false,
  campaignStatus = null,
}) {
  const isActionDisabled = isSaving || isDisabled;

  return (
    <div className="cmp-blueprint-footer">
      <button
        type="button"
        className="cmp-btn-secondary"
        disabled={isActionDisabled}
        onClick={onCancel}
      >
        Return to Catalog
      </button>

      <div className="cmp-blueprint-footer-right">
        <button
          type="button"
          className="cmp-btn-secondary"
          disabled={wizardStep === 1 || isActionDisabled}
          onClick={onPrevStep}
        >
          <i className="fas fa-chevron-left" /> Back
        </button>
        {isEditMode && isEditing && onSaveChanges && wizardStep < 6 && (
          <button
            type="button"
            className={canDirectApprove ? 'cmp-btn-success' : 'cmp-btn-primary'}
            disabled={isActionDisabled}
            onClick={onSaveChanges}
          >
            {isSaving ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Saving...
              </>
            ) : canDirectApprove ? (
              <>
                <i className="fas fa-save" /> Save Changes
              </>
            ) : campaignStatus === 'CHANGES_REQUESTED' ? (
              <>
                <i className="fas fa-paper-plane" /> Resubmit Revisions
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane" /> Submit Change Request
              </>
            )}
          </button>
        )}
        {wizardStep < 6 && (
          <button
            type="button"
            className="cmp-btn-primary"
            disabled={isActionDisabled}
            onClick={onNextStep}
          >
            Next Step <i className="fas fa-chevron-right" />
          </button>
        )}
      </div>
    </div>
  );
}
